"use strict";
/** @module utils */
/**
 * File containing functions to get and format information
 * for support tickets.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedSupportUtils = exports.SupportModalSkin = void 0;
exports.jsonAttachment = jsonAttachment;
exports.deviceInfoAttachment = deviceInfoAttachment;
exports.readFileToAttachment = readFileToAttachment;
exports.logsAttachment = logsAttachment;
exports.bryxItemsAttachment = bryxItemsAttachment;
var base64 = require("base-64");
var utf8 = require("utf8");
var device_1 = require("./device");
/**
 * @TODO Probably move into models folder.
 */
var SupportModalSkin;
(function (SupportModalSkin) {
    SupportModalSkin[SupportModalSkin["support"] = 0] = "support";
    SupportModalSkin[SupportModalSkin["sales"] = 1] = "sales";
})(SupportModalSkin || (exports.SupportModalSkin = SupportModalSkin = {}));
/**
 * Encode text as base 64.
 * @param plaintext Text to encode.
 * @result Encoded text.
 */
function utf8Base64Encode(plaintext) {
    var bytes = utf8.encode(plaintext);
    return base64.encode(bytes);
}
/**
 * Format object as base 64 encoded json string.
 * @param object Object to format.
 * @result Encoded json string.
 */
function jsonAttachment(object) {
    return utf8Base64Encode(JSON.stringify(object, null, '    '));
}
/**
 * Get and format device info as base 64 encoded json string.
 * @result Encoded json string representing device info.
 */
function deviceInfoAttachment() {
    return jsonAttachment((0, device_1.getDeviceInfo)());
}
/**
 * Read file to attachment.
 * @WARN Uses HTML5 FileReader.
 * @param file
 * @param onComplete Callback function
 */
function readFileToAttachment(file, onComplete) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        var splitParts = reader.result.split(';base64,');
        var contentType = splitParts[0].replace('data:', '');
        var fileBase64Data = splitParts[1];
        onComplete({
            key: 'success',
            attachment: {
                fileName: file.name,
                data: fileBase64Data,
                contentType: contentType,
            },
        });
    };
    reader.onerror = function () { return onComplete({
        key: 'failure',
        message: reader.error.toString(),
    }); };
}
/**
 * Read and format logs as attachment.
 * @param log Log. Type of ILog from localstorage-logger, maybe?
 * @return Logs formatted as attachment.
 */
function logsAttachment(log) {
    return utf8Base64Encode(log.exportToArray().join('\n'));
}
/**
 * Read and format bryx items from local storage as attachment.
 * @TODO Reevaluate using BryxLocal object.
 * @param local BryxLocal. Will probably change.
 * @return Bryx items formatted as attachment.
 */
function bryxItemsAttachment(local) {
    return jsonAttachment(local.getBryxItems());
}
/**
 * Class that holds the SharedSupportUtils methods.
 */
var SharedSupportUtils = /** @class */ (function () {
    function SharedSupportUtils() {
    }
    SharedSupportUtils.onOpenSupport = function () { return; };
    return SharedSupportUtils;
}());
exports.SharedSupportUtils = SharedSupportUtils;
//# sourceMappingURL=support.js.map